const n = (t, e) => e === "en" ? t : `/${e}${t.startsWith("/") ? t : `/${t}`}`;
export {
  n as g
};
//# sourceMappingURL=getUrlWithLocale-Sb9sJa1R.mjs.map
